// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { avatarClasses } from '@mui/material/Avatar';
import { rem } from '../../tokens/conversions';
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { text } from '../../tokens/themeColors/text';
export var AvatarGroup = function(_mode) {
    var bg = background(_mode);
    var bd = border(_mode);
    var tx = text(_mode);
    var override = {
        MuiAvatarGroup: {
            styleOverrides: {
                root: _define_property({}, "& .".concat(avatarClasses.root), {
                    border: "".concat(rem(1), " solid ").concat(bd.default)
                }),
                avatar: {
                    backgroundColor: bg.level200,
                    border: "".concat(rem(1), " solid ").concat(bd.default),
                    color: tx.primary
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=AvatarGroup.js.map